import React from 'react'
import CDashh from '../../features/candidateDashboard/CDashh'


function CandDash() {
  return (
    <div>
      <CDashh/>
    </div>
  )
}

export default CandDash
